import React, { useEffect, useState, useRef } from "react";
import {
  Card,
  Row,
  Col,
  Button,
  Input,
  Select,
  Modal,
  Table,
  Space,
  message,
} from "antd";
import {
  UploadOutlined,
  DownloadOutlined,
  PrinterOutlined,
  PlusOutlined,
  SearchOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";
import {
  handleStatusChange,
  handleDelete,
} from "../../components/Common/ActiveStatusChange";
import ActionsDropdown from "../../components/Common/DropDown";
import IdCard from "../../components/Common/IdCard";
import { BASE_URL } from "../../components/Common/AppConfig";
import SetAlert from "../../components/Common/SetAlert";
import DataTable from "react-data-table-component";
import dataTableCustomStyles from "../../components/Common/dataTableStyles";
import { useHistory, useLocation } from "react-router-dom";
import { CSVLink } from "react-csv";
import XLSX from "xlsx"; // Import the 'xlsx' library
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";

function AddressMaster() {
  const [userDetails, setUserDetails] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [selectedUser, setSelectedUser] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [importedData, setImportedData] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [alertMessage, setAlertMessage] = useState({ success: "", error: "" });
  const [isModalOpenUser, setIsModalOpenUser] = useState(false);
  const [filterCity, setFilterCity] = useState("");
  const [filterState, setFilterState] = useState("");
  const [filterCountry, setFilterCountry] = useState("");
  const location = useLocation();
  const [filterType, setFilterType] = useState(
    () => new URLSearchParams(location.search).get("type") || "",
  );

  const componentRef = useRef(null);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOpenModalUser = (row) => {
    setSelectedUser(row);
    setIsModalOpenUser(true);
  };
  const handleCloseModalUser = () => {
    setIsModalOpenUser(false);
  };
  const handleShareCard = async () => {
    if (!selectedUser?._id) return;
    const cardUrl = `${window.location.origin}/card/${selectedUser._id}`;
    const shareData = {
      title: "YDS Member Card",
      text: `${selectedUser.fullName || "Member"}'s YDS member card`,
      url: cardUrl,
    };
    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err) {
        if (err.name !== "AbortError") {
          message.error("Unable to share the card link.");
        }
      }
    } else if (navigator.clipboard) {
      await navigator.clipboard.writeText(cardUrl);
      message.success("Card link copied to clipboard.");
    } else {
      message.info(cardUrl);
    }
  };
  const history = useHistory();

  const handleAddUser = () => {
    history.push("/address/add");
  };

  useEffect(() => {
    fetchTagsDetails();
  }, []);

  useEffect(() => {
    setFilterType(new URLSearchParams(location.search).get("type") || "");
  }, [location.search]);

  useEffect(() => {
    if (location.state?.alertMessage) {
      setAlertMessage(location.state.alertMessage);
      history.replace({ ...location, state: undefined });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  const fetchTagsDetails = async () => {
    try {
      const response = await fetch(`${BASE_URL}/address`);
      const data = await response.json();
      if (response.ok) {
        const dataWithSerialNo = data.data.map((item, index) => ({
          ...item,
          srNo: index + 1,
        }));
        setUserDetails(dataWithSerialNo);
      } else {
        setAlertMessage({
          success: "",
          error: "Failed to fetch tags details.",
        });
      }
    } catch (error) {
      setAlertMessage({
        success: "",
        error: "An error occurred while fetching tags data",
      });
      console.error(error);
    }
  };

  const handleDeleteClick = (_id) => {
    console.log("Delete button clicked for ID:", _id);
    const Page_Url = `${BASE_URL}/address/${_id}`;
    handleDelete(_id, Page_Url, fetchTagsDetails, setAlertMessage);
  };

  const handleActiveClick = (_id) => {
    const Page_Url = `${BASE_URL}/address/status/${_id}`;
    const isActive = 1;
    const successMessageProp = "Activated Address Successfully";
    const errorMessageProp = "Failed to Update Address";
    handleStatusChange(
      isActive,
      _id,
      Page_Url,
      fetchTagsDetails,
      successMessageProp,
      errorMessageProp,
      setAlertMessage,
    );
  };

  const handleDeactiveClick = (_id) => {
    const Page_Url = `${BASE_URL}/address/status/${_id}`;
    const isActive = 0;
    const successMessageProp = "Deactivated Address Successfully";
    const errorMessageProp = "Failed to Deactivate Address";
    handleStatusChange(
      isActive,
      _id,
      Page_Url,
      fetchTagsDetails,
      successMessageProp,
      errorMessageProp,
      setAlertMessage,
    );
  };

  const handleAction = (action, row) => {
    if (action.toLowerCase() === "edit") {
      handleEdit(row);
    } else if (action.toLowerCase() === "delete") {
      handleDeleteClick(row._id);
    } else if (action.toLowerCase() === "active") {
      handleActiveClick(row._id);
    } else if (action.toLowerCase() === "deactive") {
      handleDeactiveClick(row._id);
    }
  };

  const renderActionsDropdown = (row) => (
    <ActionsDropdown row={row} handleAction={handleAction} isActive={row.isActive} />
  );

  const normalizeCase = (value) => {
    if (!value) return value;
    const trimmed = value.toString().trim();
    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
  };

  const uniqueOptions = (key, source = userDetails) =>
    [
      ...new Set(
        source.map((user) => normalizeCase(user[key])).filter(Boolean),
      ),
    ].sort((a, b) => a.localeCompare(b));

  const countryOptions = uniqueOptions("countryMaster");

  // State options narrow to the selected country; city options narrow to
  // the selected country + state - so picking India only shows Indian
  // states, and picking a state only shows that state's cities.
  const usersInSelectedCountry = filterCountry
    ? userDetails.filter(
        (user) => normalizeCase(user.countryMaster) === filterCountry,
      )
    : userDetails;
  const stateOptions = uniqueOptions("stateMaster", usersInSelectedCountry);

  const usersInSelectedCountryAndState = filterState
    ? usersInSelectedCountry.filter(
        (user) => normalizeCase(user.stateMaster) === filterState,
      )
    : usersInSelectedCountry;
  const cityOptions = uniqueOptions(
    "cityMaster",
    usersInSelectedCountryAndState,
  );

  const handleClearFilters = () => {
    setFilterCity("");
    setFilterState("");
    setFilterCountry("");
    setFilterType("");
    setSearchText("");
    history.push("/address");
  };

  const filteredData = userDetails.filter((user) => {
    const {
      _id,
      fullName,
      phone,
      email,
      dob,
      countryMaster,
      cityMaster,
      stateMaster,
      rakhi,
      patrika,
      invitation,
    } = user;
    const lowercasedSearchText = searchText.toLowerCase();

    const matchesSearch =
      !lowercasedSearchText ||
      (_id && _id.toString().includes(lowercasedSearchText)) ||
      (fullName && fullName.toLowerCase().includes(lowercasedSearchText)) ||
      (phone && phone.toLowerCase().includes(lowercasedSearchText)) ||
      (email && email.toLowerCase().includes(lowercasedSearchText)) ||
      (dob && dob.toLowerCase().includes(lowercasedSearchText)) ||
      (countryMaster &&
        countryMaster.toLowerCase().includes(lowercasedSearchText)) ||
      (cityMaster && cityMaster.toLowerCase().includes(lowercasedSearchText)) ||
      (stateMaster && stateMaster.toLowerCase().includes(lowercasedSearchText));

    const matchesCity =
      !filterCity || normalizeCase(cityMaster) === filterCity;
    const matchesState =
      !filterState || normalizeCase(stateMaster) === filterState;
    const matchesCountry =
      !filterCountry || normalizeCase(countryMaster) === filterCountry;

    let matchesType = true;
    if (filterType === "rakhi") matchesType = (rakhi || "").toLowerCase() === "yes";
    else if (filterType === "patrika") matchesType = (patrika || "").toLowerCase() === "yes";
    else if (filterType === "invitation") matchesType = (invitation || "").toLowerCase() === "yes";

    return matchesSearch && matchesCity && matchesState && matchesCountry && matchesType;
  });

  const columns = [
    {
      name: "#",
      cell: (row) => row.srNo,
      sortable: true,
      width: "70px",
    },
    {
      name: "Full Name",
      cell: (row) => (
        <div
          className="clickable-row"
          style={{ cursor: "pointer" }}
          onClick={() => handleOpenModalUser(row)}
        >
          <span>{row.fullName + " "}</span>
          <i
            className="fas fa-info"
            style={{ color: "#999", fontSize: "8px" }}
          ></i>
        </div>
      ),
      sortable: true,
      width: "250px",
    },

    { name: "Abroad", selector: (row) => row.location, sortable: true },
    {
      name: "Address",
      selector: (row) => {
        if (
          row.houseNo !== null &&
          row.streetName !== null &&
          row.area !== null
        ) {
          return row.houseNo + " " + row.streetName + " " + row.area;
        } else {
          return " ";
        }
      },
      sortable: true,
      width: "200px",
    },
    { name: "Subuarbs", selector: (row) => row.subuarb, sortable: true },
    {
      name: "City",
      selector: (row) => normalizeCase(row.cityMaster),
      sortable: true,
    },
    {
      name: "State",
      selector: (row) => normalizeCase(row.stateMaster),
      sortable: true,
    },
    {
      name: "Country",
      selector: (row) => normalizeCase(row.countryMaster),
      sortable: true,
    },
    {
      name: "Created Date",
      selector: (row) => row.createdDate || "",
      sortable: true,
      width: "175px",
    },
    {
      name: "Active",
      cell: (row) => (
        <span style={{ color: row.isActive === 1 ? "green" : "red" }}>
          {row.isActive === 1 ? "Active" : "Inactive"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => renderActionsDropdown(row),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const handleEdit = (user) => {
    history.push(`/address/edit/${user._id}`);
  };

  const handleFileUpload = async (e) => {
    try {
      const uploadedFile = e.target.files[0];
      if (!uploadedFile) return;

      if (
        uploadedFile.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        uploadedFile.type === "application/vnd.ms-excel"
      ) {
        const workbookData = await readExcelFile(uploadedFile);
        setImportedData(workbookData);
      } else if (uploadedFile.type === "text/csv") {
        const csvData = await readCSVFile(uploadedFile);
        setImportedData(csvData);
      } else {
        console.error("Unsupported file format");
      }
    } catch (error) {
      console.error("Error reading file:", error);
    }
  };

  const readExcelFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        try {
          const content = event.target.result;

          // Process the Excel file content here
          const workbookData = processExcelContent(content);

          resolve(workbookData);
        } catch (error) {
          reject(error);
        }
      };

      reader.onerror = (error) => reject(error);
      reader.readAsBinaryString(file);
    });
  };

  // Define a function to process the Excel content
  const processExcelContent = (content) => {
    try {
      // Parse the content using 'xlsx' library
      const workbook = XLSX.read(content, { type: "binary" });

      // Process the workbook and extract data as needed
      // For example, you can access sheets and data like this:
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const sheetData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      return sheetData; // Return the processed data
    } catch (error) {
      throw error;
    }
  };

  const readCSVFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const content = event.target.result;
        const rows = content.split(/\r\n|\n/);
        const data = rows.map((row) => row.split(","));
        resolve(data);
      };
      reader.onerror = (error) => reject(error);
      reader.readAsText(file);
    });
  };

  const handleSendValues = async () => {
    setSubmitting(true);

    try {
      console.log(importedData);
      const headerRow = importedData[0];
      const dataRows = importedData.slice(1);
      const transformedData = dataRows.map((row) => {
        const rowData = headerRow.reduce((acc, column, i) => {
          if (row[i] !== undefined && column !== undefined) {
            acc[column.replace(/"/g, "")] = row[i].replace(/"/g, "");
          }
          return acc;
        }, {});
        return rowData;
      });
      console.log(transformedData);
      const requestData = {
        importedData: transformedData,
      };

      const response = await fetch(`${BASE_URL}/address/imported-data`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
      if (response.ok) {
        //       history.push('/attendees');
        setAlertMessage({ success: "Event added successfully!", error: "" });
      } else {
        setAlertMessage({
          success: "",
          error: "An error occurred while adding the event.",
        });
      }
    } catch (error) {
      console.log(error);
      setAlertMessage({
        success: "",
        error: "An error occurred while adding the event.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  const dummy = [
    {
      First_Name: "John",
      Last_Name: "Doe",
      Phone: "123456789",
      Email: "john@example.com",
    },
    {
      First_Name: "Jane",
      Last_Name: "Smith",
      Phone: "987154877",
      Email: "jane@example.com",
    },
    {
      First_Name: "Alice",
      Last_Name: "Johnson",
      Phone: "5554578454",
      Email: "alice@example.com",
    },
    {
      First_Name: "Bob",
      Last_Name: "Brown",
      Phone: "7745789545",
      Email: "bob@example.com",
    },
    {
      First_Name: "Eve",
      Last_Name: "Evans",
      Phone: "8884578612",
      Email: "eve@example.com",
    },
  ];

  const dummyColumns = [
    { title: "First_Name", dataIndex: "First_Name", key: "First_Name" },
    { title: "Last_Name", dataIndex: "Last_Name", key: "Last_Name" },
    { title: "Phone", dataIndex: "Phone", key: "Phone" },
    { title: "Email", dataIndex: "Email", key: "Email" },
  ];

  const generatePDF = async () => {
    const inch = 72;

    // ====== Page & Layout Setup ======
    const PAGE_WIDTH = 595.28; // A4 width (points)
    const PAGE_HEIGHT = 841.89; // A4 height (points)

    // ----- Adjustable Page Margins -----
    const LEFT_MARGIN = 0.15 * inch; // Left margin
    const RIGHT_MARGIN = 0 * inch; // Right margin
    const TOP_MARGIN = 0.7 * inch; // Top margin
    const BOTTOM_MARGIN = 0.4 * inch; // Bottom margin

    // ----- Label Setup -----
    const LABEL_WIDTH = 2.71654 * inch;
    const LABEL_HEIGHT = 1.33858 * inch;

    // ====== Compute number of labels per row/column ======
    const NUM_ACROSS = 3;
    const NUM_DOWN = 8;

    // ====== Initialize PDF ======
    const pdfDoc = await PDFDocument.create();
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

    const countryCodes = {};
    let page = pdfDoc.addPage([PAGE_WIDTH, PAGE_HEIGHT]);

    // ====== Sort by Country ======
    filteredData.sort((a, b) =>
      a.countryMaster && b.countryMaster
        ? a.countryMaster.localeCompare(b.countryMaster)
        : 0,
    );

    // ====== Draw Labels ======
    filteredData.forEach((user, index) => {
      const col = index % NUM_ACROSS;
      const row = Math.floor(index / NUM_ACROSS) % NUM_DOWN;

      if (index % (NUM_ACROSS * NUM_DOWN) === 0 && index !== 0) {
        page = pdfDoc.addPage([PAGE_WIDTH, PAGE_HEIGHT]);
      }

      // ====== Apply margins in layout ======
      const x = col * LABEL_WIDTH + col; // adding 0.2 inch gap between labels
      const y = PAGE_HEIGHT - TOP_MARGIN - (row + 1) * LABEL_HEIGHT; // bottom aligns inside cell

      // Determine prefix
      let prefix = "";
      if (user.invitation === "yes") prefix = "INV/";
      else if (user.patrika === "yes") prefix = "P/";
      else if (user.rakhi === "yes") prefix = "Rakh/";

      // Country code counter
      const countryCode = user.countryMaster
        ? user.countryMaster.substring(0, 2).toUpperCase()
        : "";
      if (!countryCodes[countryCode]) countryCodes[countryCode] = 1;

      const labelCode = `${prefix}${countryCode}${countryCodes[countryCode]}`;
      countryCodes[countryCode]++;

      // House/street + city/state/country/pincode share one wrapped block so
      // nothing gets dropped - the whole label (code + name + this block)
      // is capped at MAX_LINES; if the address is long, the font shrinks
      // (down to MIN_FONT_SIZE) rather than adding a 5th/6th line.
      const addressPart = [
        user.houseNo,
        user.streetName,
        user.area,
        user.cityMaster,
        user.stateMaster,
        user.countryMaster,
        user.pincode,
      ]
        .map((part) => (part || "").toString().trim())
        .filter(Boolean)
        .join(" ")
        .replace(/\s+/g, " ")
        .toLowerCase();

      const wrapText = (text, maxCharsPerLine) => {
        if (!text) return [];
        const words = text.split(" ");
        const lines = [];
        let line = "";

        for (let word of words) {
          if ((line + word).length > maxCharsPerLine) {
            lines.push(line.trim());
            line = word + " ";
          } else {
            line += word + " ";
          }
        }
        if (line.trim()) lines.push(line.trim());
        return lines;
      };

      // ====== Label Padding ======
      let PADDING_LEFT = 17; // space from label's left edge
      let PADDING_TOP = 20; // space from label's top edge
      let PADDING_BOTTOM = 6; // space from label's bottom edge

      const MAX_LINES = 5; // labelCode + name + address, total, never more
      const FIXED_LINES = 2; // labelCode, name
      const BASE_FONT_SIZE = 9;
      const MIN_FONT_SIZE = 4;
      const BASE_MAX_CHARS = 36;

      // ====== Find the largest font size where everything fits within MAX_LINES ======
      let fontSize = MIN_FONT_SIZE;
      let lineSpacing = fontSize + 3;
      let addressLines = wrapText(
        addressPart,
        Math.round((BASE_MAX_CHARS * BASE_FONT_SIZE) / MIN_FONT_SIZE),
      );

      for (let size = BASE_FONT_SIZE; size >= MIN_FONT_SIZE; size -= 0.5) {
        const maxChars = Math.round((BASE_MAX_CHARS * BASE_FONT_SIZE) / size);
        const candidateLines = wrapText(addressPart, maxChars);

        if (
          candidateLines.length <= MAX_LINES - FIXED_LINES ||
          size <= MIN_FONT_SIZE
        ) {
          fontSize = size;
          lineSpacing = size + 3;
          addressLines = candidateLines;
          break;
        }
      }

      const textLines = [labelCode, user.fullName || "", ...addressLines];

      // ====== Draw Text ======
      textLines.forEach((line, i) => {
        // Apply padding offsets
        const textX = x + PADDING_LEFT;
        const textY = y + LABEL_HEIGHT - PADDING_TOP - i * lineSpacing;

        // Stop drawing if it would go below bottom padding
        if (textY - fontSize < y + PADDING_BOTTOM) return;

        page.drawText(line.trim(), {
          x: textX,
          y: textY,
          size: fontSize,
          font,
          color: rgb(0, 0, 0),
        });
      });
    });

    // ====== Open for print preview instead of forcing a download ======
    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, "_blank");
  };

  const handlePrint = () => {
    if (filteredData.length > 0) {
      console.log(filteredData);
      // Sort userDetails by countryMaster
      filteredData.sort((a, b) =>
        a.countryMaster && b.countryMaster
          ? a.countryMaster.localeCompare(b.countryMaster)
          : 0,
      );

      // Create a new HTML page for printing
      const printWindow = window.open("", "", "width=600,height=600");
      printWindow.document.open();

      // Define the number of elements to be printed per page
      const elementsPerPage = 24;

      // Define the margin for the top of each page
      const topMargin = "50px";

      // Keep track of the serial number for each country
      const countryCodes = {};

      for (let i = 0; i < filteredData.length; i += elementsPerPage) {
        // Start a new page with custom margins
        printWindow.document.write(`
        <html>
          <head>
            <style>
              /* Center the title using CSS */
              title {
                text-align: right;
              }
              .page {
                margin-top: ${i === 0 ? topMargin : "0"};
                page-break-before: always;
              }
              .grid-container {
                display: grid;
                grid-template-columns: repeat(3, 1fr); /* 3 columns */
                grid-auto-rows: 110px; /* Fixed row height of 100px (adjust as needed) */
                grid-gap: 20px; /* Spacing between grid items */
              }
              .grid-item {
                padding: 20px 10px 10px 10px;
                border: none;
                font-size: 11px;
                text-align: left; /* Center-align text within grid items */
                width: 200px; /* Fixed width (adjust as needed) */
                font-family: 'Poppins', sans-serif;
              }
            </style>
          </head>
          <body>
            <title>Yds</title>
      `);

        // Loop through userDetails, group by country, and display data in a grid
        printWindow.document.write(`
        <div class="grid-container page">
      `);

        for (
          let j = i;
          j < i + elementsPerPage && j < filteredData.length;
          j++
        ) {
          const user = filteredData[j];
          const countryCode = user.countryMaster
            ? user.countryMaster.substring(0, 2).toUpperCase()
            : "";
          if (!countryCodes[countryCode]) {
            countryCodes[countryCode] = 1;
          }

          printWindow.document.write('<div class="grid-item">');
          let prefix = "";

          if (user.invitation === "yes") {
            prefix = "INV/";
          } else if (user.patrika === "yes") {
            prefix = "P/";
          } else if (user.rakhi === "yes") {
            prefix = "Rakh/";
          }

          const address =
            (user.houseNo || " ") +
            " " +
            (user.streetName || " ") +
            " " +
            (user.area || " ") +
            " " +
            (user.cityMaster || " ") +
            " " +
            (user.stateMaster || " ") +
            " " +
            (user.countryMaster || " ") +
            " " +
            (user.pincode || " ");
          if (address.length > 95) {
            printWindow.document.write(
              `<div style="font-size:10px">${prefix}${countryCode}${countryCodes[countryCode]}</div>`,
            );
            printWindow.document.write(
              `<div><strong style="font-size:12px"> ${
                user.fullName || " "
              }</strong></div>`,
            );
            printWindow.document.write(
              `<div style="font-size:10px">${address}</div>`,
            );
          } else {
            printWindow.document.write(
              `<div style="font-size:10px">${prefix}${countryCode}${countryCodes[countryCode]}</div>`,
            );
            printWindow.document.write(
              `<div><strong style="font-size:12px"> ${
                user.fullName || " "
              }</strong></div>`,
            );
            printWindow.document.write(`<div>${address}</div>`);
          }

          printWindow.document.write("</div>");

          // Increment the serial number for the country
          countryCodes[countryCode]++;
        }

        // Close the HTML structure for this page
        printWindow.document.write("</div></body></html>");
      }

      printWindow.document.close();

      // Print the new pages
      printWindow.print();
      printWindow.close();
    } else {
      // Handle the case where there is no data
      console.log("No data to print");
    }
  };

  useEffect(() => {
    // Trigger the print action after data has been fetched
    if (userDetails.length > 0) {
      componentRef.current && componentRef.current.click();
    }
  }, [userDetails]);

  const isSelectedUser = Object.keys(selectedUser).length > 0;

  return (
    <div className="content">
      <Row>
        <Col md={24}>
          <Card title="Address Details ...">
            <div
              className="mb-3"
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 12,
              }}
            >
              <Space wrap size={8}>
                <CSVLink
                  data={userDetails}
                  filename="SponsorData"
                  style={{ textDecoration: "none" }}
                >
                  <Button type="primary" icon={<DownloadOutlined />}>
                    Export to Excel
                  </Button>
                </CSVLink>
                <Button
                  type="primary"
                  icon={<UploadOutlined />}
                  onClick={handleOpenModal}
                >
                  Import to Excel
                </Button>
                {userDetails.length > 0 && (
                  <Button
                    type="primary"
                    icon={<PrinterOutlined />}
                    onClick={generatePDF}
                  >
                    Print
                  </Button>
                )}
              </Space>
              <Space wrap size={8}>
                <Input
                  type="text"
                  placeholder="Search..."
                  prefix={<SearchOutlined style={{ color: "rgba(0,0,0,0.35)" }} />}
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  style={{ width: 220 }}
                />
                <Button type="primary" icon={<PlusOutlined />} onClick={handleAddUser}>
                  Add
                </Button>
              </Space>
            </div>
            <Row gutter={16} className="mb-3">
              <Col xs={24} sm={12} md={5} className="mb-2">
                <label htmlFor="filterCountry" style={{ display: "block", marginBottom: 4 }}>
                  Country
                </label>
                <Select
                  id="filterCountry"
                  showSearch
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                  }
                  value={filterCountry}
                  onChange={(value) => {
                    setFilterCountry(value);
                    setFilterState("");
                    setFilterCity("");
                  }}
                  style={{ width: "100%" }}
                  options={[
                    { value: "", label: "All Countries" },
                    ...countryOptions.map((country) => ({ value: country, label: country })),
                  ]}
                />
              </Col>
              <Col xs={24} sm={12} md={5} className="mb-2">
                <label htmlFor="filterState" style={{ display: "block", marginBottom: 4 }}>
                  State
                </label>
                <Select
                  id="filterState"
                  showSearch
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                  }
                  value={filterState}
                  onChange={(value) => {
                    setFilterState(value);
                    setFilterCity("");
                  }}
                  style={{ width: "100%" }}
                  options={[
                    { value: "", label: "All States" },
                    ...stateOptions.map((state) => ({ value: state, label: state })),
                  ]}
                />
              </Col>
              <Col xs={24} sm={12} md={5} className="mb-2">
                <label htmlFor="filterCity" style={{ display: "block", marginBottom: 4 }}>
                  City
                </label>
                <Select
                  id="filterCity"
                  showSearch
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                  }
                  value={filterCity}
                  onChange={(value) => setFilterCity(value)}
                  style={{ width: "100%" }}
                  options={[
                    { value: "", label: "All Cities" },
                    ...cityOptions.map((city) => ({ value: city, label: city })),
                  ]}
                />
              </Col>
              <Col xs={24} sm={12} md={5} className="mb-2">
                <label htmlFor="filterType" style={{ display: "block", marginBottom: 4 }}>
                  Type
                </label>
                <Select
                  id="filterType"
                  showSearch
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                  }
                  value={filterType}
                  onChange={(value) => setFilterType(value)}
                  style={{ width: "100%" }}
                  options={[
                    { value: "", label: "All" },
                    { value: "rakhi", label: "Rakhi" },
                    { value: "patrika", label: "Patrika" },
                    { value: "invitation", label: "Invitation" },
                  ]}
                />
              </Col>
              <Col
                xs={24}
                sm={12}
                md={4}
                className="mb-2"
                style={{ display: "flex", alignItems: "flex-end" }}
              >
                <Button block onClick={handleClearFilters}>
                  Clear Filters
                </Button>
              </Col>
            </Row>
            <SetAlert
              alertMessage={alertMessage}
              setAlertMessage={setAlertMessage}
            />
            <DataTable
              className="table-nowrap custom-data-table"
              customStyles={dataTableCustomStyles}
              columns={columns}
              data={filteredData}
              pagination
              highlightOnHover
              noHeader
              responsive
              keyField="_id"
            />
          </Card>
        </Col>
      </Row>

      <Modal
        title="Import Excel"
        open={isModalOpen}
        onCancel={handleCloseModal}
        footer={[
          <Button key="cancel" onClick={handleCloseModal}>
            Cancel
          </Button>,
          <Button key="add" type="primary" onClick={handleSendValues}>
            Add
          </Button>,
        ]}
      >
        <div className="form-group mt-4 mb-2">
          <label htmlFor="data">Upload Excel</label>
          <input
            type="file"
            className="form-control"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            onChange={handleFileUpload}
            style={{ width: "100%" }}
          />
        </div>
        <div className="form-group mt-4 mb-2">
          <Card size="small" title="Example for reference">
            <Table
              size="small"
              columns={dummyColumns}
              dataSource={dummy}
              pagination={false}
              rowKey={(row, index) => index}
            />
          </Card>
        </div>
      </Modal>

      {isSelectedUser && (
        <Modal
          title="Member ID Card"
          open={isModalOpenUser}
          onCancel={handleCloseModalUser}
          width={760}
          footer={[
            <Button key="share" icon={<ShareAltOutlined />} onClick={handleShareCard}>
              Share
            </Button>,
            <Button key="cancel" onClick={handleCloseModalUser}>
              Close
            </Button>,
          ]}
        >
          <IdCard user={selectedUser} />
        </Modal>
      )}
    </div>
  );
}

export default AddressMaster;
